import { render, staticRenderFns } from "./mc-waste.vue?vue&type=template&id=73aca5a8&scoped=true"
import script from "./mc-waste.vue?vue&type=script&lang=ts"
export * from "./mc-waste.vue?vue&type=script&lang=ts"
import style0 from "./mc-waste.vue?vue&type=style&index=0&id=73aca5a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aca5a8",
  null
  
)

export default component.exports